import { render } from "./AllDoctors.vue?vue&type=template&id=07194920"
import script from "./AllDoctors.vue?vue&type=script&lang=js"
export * from "./AllDoctors.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__